// The Stewardship marketing topics: a code-level constant, not a table.
//
// CONSUMER: both.
//
// Plan: docs/design/marketing-hub.md section 6 ("about ten Stewardship
// topics; the vocabulary lock applies; edits are a PR"). A topic is what
// a family can choose to hear about (the preference center, slice 3) and
// what a piece is filed under (the content library, slice 7).
//
// A TOPIC IS A PART OF LIFE, NEVER A PRODUCT (plan rule 4; audit F19,
// Grant's call 2026-09-29). A family is relevant to owning a home or to
// retirement; the OS never decides it is relevant to "umbrella policy"
// and fires. The first list was product-led ("Home and auto insurance",
// "Private money lending"), which is exactly the line rule 4 draws. Product
// families live on the candidate (`productFamily`), separately. Adding a
// topic is a pull request, so the list is reviewed the way the vocabulary is.

export interface MarketingTopic {
  /** Stable key, stored in contact_marketing_preferences.topics. */
  key: string;
  /** What the family sees in the preference center. */
  label: string;
  /** The companies whose pieces file under it. */
  companies: ReadonlyArray<"mortgage" | "insurance" | "planning" | "realty" | "financial">;
}

export const MARKETING_TOPICS: ReadonlyArray<MarketingTopic> = [
  { key: "owning_a_home", label: "Owning a home", companies: ["insurance", "mortgage", "realty"] },
  { key: "buying_or_selling", label: "Buying or selling a home", companies: ["realty", "mortgage"] },
  { key: "home_value", label: "Your home's value", companies: ["realty", "mortgage"] },
  { key: "protecting_what_you_own", label: "Protecting what you own", companies: ["insurance"] },
  { key: "investing_in_property", label: "Investing in property", companies: ["mortgage", "realty"] },
  { key: "saving_and_investing", label: "Saving and investing", companies: ["financial"] },
  { key: "retirement", label: "Planning for retirement", companies: ["financial", "planning"] },
  { key: "taxes", label: "Tax season", companies: ["financial", "planning"] },
  { key: "family_future", label: "Your family's future", companies: ["planning", "financial"] },
  { key: "health_and_medicare", label: "Health coverage and Medicare", companies: ["planning"] },
  { key: "stewardship_news", label: "News from Stewardship", companies: ["mortgage", "insurance", "planning", "realty", "financial"] },
] as const;

export const MARKETING_TOPIC_KEYS: ReadonlySet<string> = new Set(
  MARKETING_TOPICS.map((t) => t.key),
);

export function isMarketingTopicKey(value: unknown): value is MarketingTopic["key"] {
  return typeof value === "string" && MARKETING_TOPIC_KEYS.has(value);
}
